import * as React from 'react';
import { Redirect } from 'react-router';
import * as _ from 'underscore';

import { Filter } from '../../../ts/helpers/Filter';
import { IWorkbookInfo } from '../../../ts/models/IWorkbookInfo';
import { Favorites } from '../../../ts/resources/Favorites';
import { Workbooks } from '../../../ts/resources/Workbooks';
import { ServiceLocator } from '../../ServiceLocator';
import { RouterError } from '../RouterHelpers/RouterError';
import { SpacesSiteUrls } from '../SpacesSiteUrls';

export interface RedirectToFavoritedWorkbookProviderProps {
  readonly workbookId: string;
  readonly urls: SpacesSiteUrls;
}

export interface RedirectToFavoritedWorkbookProviderState {
  readonly workbookExists: boolean;
  readonly hasError: boolean;
}

const InitialState: RedirectToFavoritedWorkbookProviderState = {
  workbookExists: false,
  hasError: false
};

export class RedirectToFavoritedWorkbookProvider extends React.PureComponent<RedirectToFavoritedWorkbookProviderProps, RedirectToFavoritedWorkbookProviderState> {
  private unmounted: boolean = false;

  public constructor(props: RedirectToFavoritedWorkbookProviderProps) {
    super(props);
    this.state = InitialState;
  }

  public render(): JSX.Element {
    if (this.state.hasError) {
      return <RouterError errorType={'workbook-removed-favorite'} urls={this.props.urls} />;
    } else if (this.state.workbookExists) {
      return <Redirect to={this.props.urls.workbookPath(this.props.workbookId)} />;
    }

    return null;
  }

  public async componentDidMount() {
    if (_.isUndefined(this.props.workbookId)) {
      this.setToErrorStateAndRemoveFromFavorites();
      return;
    }

    try {
      const Workbooks = ServiceLocator.get<Workbooks>('Workbooks');
      const workbook: IWorkbookInfo = await Workbooks.all()
        .withFilters([Filter.fieldEq('id', this.props.workbookId)])
        .getFirst();

      if (workbook) {
        this.updateState({ workbookExists: true });
      } else {
        this.setToErrorStateAndRemoveFromFavorites();
      }

    } catch (e) {
      this.setToErrorStateAndRemoveFromFavorites();
    }
  }

  private setToErrorStateAndRemoveFromFavorites() {
    const Favorites = ServiceLocator.get<Favorites>('Favorites');
    Favorites.remove(this.props.workbookId, 'workbook');
    this.updateState({ hasError: true });
  }

  public componentWillUnmount() {
    this.unmounted = true;
  }

  private updateState<K extends keyof RedirectToFavoritedWorkbookProviderState>(newState: Pick<RedirectToFavoritedWorkbookProviderState, K>): void {
    if (!this.unmounted) {
      this.setState(newState);
    }
  }
}
